module.exports = __webpack_public_path__ + "img/ic_round-add.8fe1b614.svg";